import { generateTableSlice } from "./sliceTable";

const slicePatientActivityTable = generateTableSlice("patientActivity");

export const ActionsPatientActivityTable = slicePatientActivityTable.actions;
export const ReducerPatientActivityTable = slicePatientActivityTable.reducer;
